'use strict';

import TWER_PRELOADER from './modules/preloader';
import TWER_GALLERY from './modules/gallery';
import TWER_CATEGORY_SWITCHER from './modules/category-switcher';
import TWER_ADDONS from './modules/addons';
import TWER_TOUR from './modules/tour';
import TwerLayers from './modules/layers';
import TrewelerGallery from './modules/gallery';

window.TWER = {
  clusterDataDump: [],
  storeLocatorDataDump: [],
  clusterData: {},
  clusterDataSources: {},
  routeData: {},
  map: {},
  popups: [],
  globalClusterStatus: true,
  data: {},
  clusterColor: '#4b7715',
  markersDataDump: [],
  markers: [],
  markersIgnoredClusters: [],
  boundsData: [],
  fitBounds: true,
  animationDelayClose: 400,
  animationDelayOpen: 250,
  tour: false,
  tourAutoRun: false,
  tourInProgress: false,
  geolocateControl: false,
  ajaxLoading: false,
  currentMapPageId: 0,
  allMapMarkers: [],

  markerLocation : false,

  markerLocationProps : {
    id: 0,
    marker_style: 'default',
    point_halo_color: '#fff',
    point_halo_opacity: 0.5,
    point_color: '#4b7715',
    custom_marker_img: '',
    cursor: 'pointer',
    anchor: 'center'
  },

  initAllMapMarkers: function() {
    const data = new FormData();

    data.append( 'action', 'twer_loadMapMarkers' );
    data.append( 'mapId', this.currentMapPageId);

    fetch(treweler_params.ajax_url, {
      method: "POST",
      credentials: 'same-origin',
      body: data
    })
    .then((response) => response.json())
    .then((data) => {
      if (data) {
        this.allMapMarkers = data;
      }
    })
    .catch((error) => {
      console.error(error);
    });

  },

  initMap: function(data) {

    // Set data global
    TWER.data = data;

    TWER.clusterDataSources = TWER.clusterData.features;

    this.currentMapPageId = data.mapPageId;

    //this.initAllMapMarkers();

    // Parse access token from php
    mapboxgl.accessToken = data.accessToken;

    // Set global cluster variable
    TWER.clusterColor = data.clusterColor;
    TWER.allowCluster = data.allowCluster;

    const params = {
      container: 'twer-map',
      style: data.style,
      center: data.center,
      minZoom: data.minZoom,
      maxZoom: data.maxZoom,
      zoom: data.zoom,
      bearing: data.iniBearing,
      pitch: data.iniPitch,
      maxPitch: data.maxPitch,
      minPitch: data.minPitch,
      attributionControl: false,
      logoPosition: data.wordmarkPosition,
      projection: {
        name: data.projection
      },
      fadeDuration: 0 // Disable fade animation for clusters
    };

    // Add Restrict map panning to an area
    if (data.restrictPanning) {
      params.maxBounds = data.restrictPanningData;
    }

    // Init map by values from php
    TWER.map = new mapboxgl.Map(params);


    new TwerLayers(data);
    TWER.map.on('style.load', () => {
      TWER.map.setFog({});
      if(data.style === 'mapbox://styles/mapbox/standard-beta') {
        if (data.mapLightPreset) {
          TWER.map.setConfigProperty('basemap', 'lightPreset', data.mapLightPreset);
        }
      }

    });

    // Disables the "drag to pan" interaction.
    if (data.disableDragPan) {
      TWER.map.dragPan.disable();
    }

    // Add Attribution Compact Control param
    TWER.map.addControl(new mapboxgl.AttributionControl({
      compact: data.compactAttribution
    }), data.attributionPosition);

    // Languanges Config
    if (data.mapLanguange !== 'browser') {
      mapboxgl.setRTLTextPlugin('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js');
      TWER.map.addControl(new MapboxLanguage({
        defaultLanguage: data.mapLanguange
      }));

      setTimeout(function() {
        TWER.map.setLayoutProperty('country-label', 'text-field', [
          'get',
          'name_' + data.mapLanguange
        ]);
      }, 200);
    }

    if (!data.allowBearing) {
      TWER.map.dragRotate.disable();
      TWER.map.touchZoomRotate.disableRotation();
    }

    // Add additional controls (parse data from php)
    if (data.scaleControl) {
      TWER.map.addControl(new mapboxgl.ScaleControl({
        maxWidth: 100,
        unit: data.scaleControlUnit ? data.scaleControlUnit : 'imperial'
      }), data.scaleControlPosition);
    }

    // Add fullscreen control button
    if (data.fullscreenControl) {
      TWER.map.addControl(new mapboxgl.FullscreenControl(), data.fullscreenControlPosition);
    }

    // Add search control field
    if (data.searchControl) {
      TWER.MapboxGeocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        zoom: 14,
        placeholder: data.searchControlPlaceholder,
        mapboxgl: mapboxgl,
        marker: false
      });
      TWER.map.addControl(TWER.MapboxGeocoder, data.searchControlPosition);
    }

    // Add zoom controls for map
    if (data.zoomControl) {
      TWER.map.addControl(new mapboxgl.NavigationControl(), data.zoomControlPosition);
    }



    // Enable/disable shortcode scrollzoom
    if (!data.scrollZoom) {
      TWER.map.scrollZoom.disable();
    }

    //if (!data.allowStoreLocator) {
    // Call another handlers after main init method
    TWER.onLoadMap();
    if (data.allowCluster) {
      TWER.clustersHandlers();
    }
    TWER.onClickMap();
    //}

    // Init fitbounds settings
    TWER.boundsData = TWER.map.getBounds().toArray();
    TWER.fitBounds = data.fitBounds;

    TWER.map.setRenderWorldCopies(data.worldCopy);

    // Tour logic
    new TWER_TOUR(data);

    // Call categories switcher handlers
    new TWER_CATEGORY_SWITCHER();

    // Addons code
    new TWER_ADDONS();

    // Gallery
    new TrewelerGallery();

    // Call preloader handlers
    new TWER_PRELOADER();


    jQuery(document).on('click', '.js-twer-close-popup-btn', e => {
      e.preventDefault();

      const match = e.target.closest('.js-twer-popup').classList.value.match(/twer-popup-id-\d+/gm);
      const matchedId = match[0] !== undefined ? parseInt(match[0].replace(/^\D+/g, '')) : '';

      if(matchedId !== '') {
        TWER.closePopups([matchedId]);
      }
    });
  },



  onLoadMap: function() {
    TWER.map.on('load', async () => {


      // Add overlay for map
      const alpha = TWER.data.bgOverlay.replace(/^.*,(.+)\)/, '$1');
      const isAlpha = isNaN(parseFloat(alpha)) ? 1 : parseFloat(alpha);

      if (TWER.data.bgOverlay && isAlpha !== 0) {
        TWER.map.addLayer({
          id: 'bg-layer',
          type: 'background',
          paint: {
            'background-color': TWER.data.bgOverlay
          }
        });
      }

      if (!TWER.isEmpty(TWER.clusterData)) {


        // Add source data
        TWER.map.addSource('locations', {
          type: 'geojson',
          data: TWER.clusterData,
          generateId: true,
          cluster: true,
          clusterMaxZoom: TWER.data.clusterMaxZoom,
          clusterRadius: 50,
        });

        // Add clusters layer
        TWER.map.addLayer({
          id: 'clusters',
          type: 'circle',
          source: 'locations',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': '#fff',
            'circle-radius': 40,
            'circle-stroke-color': '#ac2929',
            'circle-opacity': 0,
            'circle-stroke-opacity': 0,
          }
        });

        // Add numbers for clusters
        TWER.map.addLayer({
          id: 'markerPnt',
          type: 'symbol',
          source: 'locations',
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{point_count_abbreviated}',
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-size': 0
          }
        });

        // Add default layer points (aka markers in code)
        TWER.map.addLayer({
          id: 'unclustered-point',
          type: 'circle',
          source: 'locations',
          filter: ['!', ['has', 'point_count']],
          paint: {
            'circle-color': '#22b719',
            'circle-radius': 15,
            'circle-stroke-width': 1,
            'circle-stroke-color': '#fff',
            'circle-stroke-opacity': 0,
            'circle-opacity': 0
          },
        });

        // Add static markers to map
        if (TWER.clusterData.features.length > 0) {
          let i = 0;

          const markersIdsRemoved = [];

          for (const feature of TWER.clusterData.features) {
            const marker = {};
            const coords = feature.geometry.coordinates;
            const props = feature.properties;
            const desc = props?.description;


            const markerElement = TWER.createNewMarker(props, coords, desc);

            marker.element = new mapboxgl.Marker(markerElement).setLngLat(coords).addTo(TWER.map);
            TWER.__afterCreateNewMarker(markerElement, props, coords);
            marker.feature = feature;
            marker.show = true;

            // Remove marker from clusterData if it ignored cluster
            if (!props.allowMarkerCluster && TWER.allowCluster) {
              markersIdsRemoved.push(i);
              // Push current markers to array
              TWER.markersIgnoredClusters.push(marker);
            } else {
              // Push current markers to array
              TWER.markers.push(marker);
            }

            i++;
          }

          if (markersIdsRemoved.length > 0) {
            const indexSet = new Set(markersIdsRemoved);

            let inClusterFeatures = [];
            let outClusterFeatures = [];

            TWER.clusterData.features.filter((value, i) => {
              if(!indexSet.has(i)){
                inClusterFeatures.push(value);
              }  else {
                outClusterFeatures.push(value);
              }
            });

            TWER.clusterData.features = TWER.clusterData.features.filter((value, i) => !indexSet.has(i));
            TWER.outClusterFeatures = outClusterFeatures;

            TWER.map.getSource('locations').setData(TWER.clusterData);
          }
        }

        let notClustersData = [];
        let clustersData = [];
        let viewPortMarkersData = [];
        let markersInViewPort = [];
        let clusters = [];

        function markerExists(id, array) {
          return array.some(function(marker) {
            return marker.id === id;
          });
        }

        TWER.map.on('render', () => {
          if (!TWER.map.isSourceLoaded('locations') || !TWER.allowCluster) return;


          //console.log('render TW');
          notClustersData = [];
          clustersData = [];
          viewPortMarkersData = [];
          markersInViewPort = [];

          const viewPortMarkers = TWER.map.querySourceFeatures('locations', {
            sourceLayer: ['unclustered-point']
          });
          const featuresNotClusters = TWER.map.querySourceFeatures('locations', {
            filter: ['!', ['has', 'point_count']],
            sourceLayer: ['unclustered-point']
          });
          const featuresClusters = TWER.map.querySourceFeatures('locations', {
            filter: ['has', 'point_count'],
            sourceLayer: ['unclustered-point']
          });

          if (viewPortMarkers.length > 0) {
            for (let i = 0; i < viewPortMarkers.length; i++) {
              if (!markerExists(viewPortMarkers[i].id, viewPortMarkersData)) {
                viewPortMarkersData.push(viewPortMarkers[i]);
              }
            }
          }

          if (featuresNotClusters.length > 0) {
            for (let i = 0; i < featuresNotClusters.length; i++) {
              if (!markerExists(featuresNotClusters[i].id, notClustersData)) {
                notClustersData.push(featuresNotClusters[i]);
              }
            }
          }

          if (featuresClusters.length > 0) {
            for (let i = 0; i < featuresClusters.length; i++) {
              if (!markerExists(featuresClusters[i].id, clustersData)) {
                clustersData.push(featuresClusters[i]);
              }
            }
          }

          // Detect if clusters show
          if (clustersData.length !== 0 && TWER.markers.length > 0) {
            //console.log('TW 1');
            // Get only show in viewport static markers
            for (let i = 0; i < TWER.markers.length; i++) {
              if (TWER.map.getBounds().contains(TWER.markers[i].element.getLngLat())) {
                markersInViewPort.push(TWER.markers[i]);
              }
            }




            for (let i = 0; i < markersInViewPort.length; i++) {
              let notClustersMarkersIds = [];
              let viewPortMarkersIds = markersInViewPort[i].feature.properties.id;
              for (let j = 0; j < notClustersData.length; j++) {
                notClustersMarkersIds.push(notClustersData[j].properties.id);
              }

              if (notClustersMarkersIds.includes(viewPortMarkersIds)) {
                  markersInViewPort[i].show = true;
                  markersInViewPort[i].element._element.style.display = 'block';
              } else {

                // Trick if cluster enabled and we in tour progress
                if (!TWER.tourInProgress) {
                  TWER.closePopups([markersInViewPort[i].feature.properties.id]);
                }


                markersInViewPort[i].show = false;
                markersInViewPort[i].element._element.style.display = 'none';

              }
            }

            // Check if show only one cluster
            const clustersDataLength = clustersData.length;
            const clustersLength = clusters.length;
            let onlyOneClusterFlag = false;

            if (!onlyOneClusterFlag) {
              const currentClustersIds = [];
              for (let j = 0; j < clustersData.length; j++) {
                currentClustersIds.push(clustersData[j].id);
              }

              if (clusters.length !== 0) {
                const clustersIdsRemoved = [];
                for (let i = 0; i < clusters.length; i++) {


                  if (!currentClustersIds.includes(clusters[i].feature.id)) {
                    clusters[i].feature = {};
                    clusters[i].element.remove();
                    clusters[i].show = false;
                    clustersIdsRemoved.push(i);
                  }
                }

                //for (let i = 0; i < clustersData.length; i++) {
                //    for (let j = 0; j < clusters.length; j++) {
                //      const counterCluster = parseInt(clusters[i].element.getElement().getElementsByClassName('marker__center')[0].textContent);
                //      clustersData[i].properties.point_count
                //    }
                //}

                const indexSet = new Set(clustersIdsRemoved);

                clusters = clusters.filter((value, i) => !indexSet.has(i));
              }



              // Create and show clusters
              for (let i = 0; i < clustersData.length; i++) {
                let skipCluster = false;
                if (clusters.length !== 0) {
                  for (let j = 0; j < clusters.length; j++) {

                    const counterCluster = parseInt(clusters[j].element.getElement().getElementsByClassName('marker__center')[0].textContent);
//  &&
                    if (clusters[j].feature.id === clustersData[i].id) {
                      skipCluster = true;

                      if(counterCluster !== clustersData[i].properties.point_count) {
                        clusters[j].element.getElement().getElementsByClassName('marker__center')[0].textContent = clustersData[i].properties.point_count;
                      }
                     // console.log(clusters[j], clustersData[i])
                    }


                  }
                }



                if (skipCluster) continue;




                const props = clustersData[i].properties;
                const coords = clustersData[i].geometry.coordinates;


                let clusterElement = TWER.createNewCluster(props);
                let cluster = {};

                cluster.element = new mapboxgl.Marker(clusterElement).setLngLat(coords).addTo(TWER.map);

                //console.log(clusterElement, cluster);

                cluster.feature = clustersData[i];
                cluster.show = true;
                clusters.push(cluster);
              }
            }

            TWER.globalClusterStatus = true;
          } else {

            for (let i = 0; i < TWER.markers.length; i++) {
              if(lodash.has(TWER.markers[i], 'insideStoreLocator')) {

                if (TWER.markers[i].insideStoreLocator) {
                  if (TWER.markers[i].show === false) {
                    TWER.markers[i].show = true;
                    TWER.markers[i].element._element.style.display = 'block';
                  }

                  if (TWER.markers[i].mustShowInCluster) {
                    TWER.markers[i].element._element.style.display = 'block';
                  }
                }
              } else {
                if (TWER.markers[i].show === false) {
                  TWER.markers[i].show = true;
                  TWER.markers[i].element._element.style.display = 'block';
                }
              }

            }


            const clustersIdsRemoved1 = [];
            for (let i = 0; i < clusters.length; i++) {
              if (clusters[i].show === true) {
                clusters[i].show = false;
                clusters[i].feature = {};
                clusters[i].element.remove();
                clustersIdsRemoved1.push(i);
              }
            }
            const indexSet1 = new Set(clustersIdsRemoved1);
            clusters = clusters.filter((value, i) => !indexSet1.has(i));
          }

        });

        TWER.map.on('zoom', (event) => {
          if (typeof event.originalEvent !== 'undefined') {
            TWER.tourInProgress = false;
          }
        });

        // Fire events after `zoomend` event
        TWER.map.on('zoomend', function(event) {
          // Check if zoom change after mousewheel or controls buttons
          if (typeof event.originalEvent !== 'undefined') {
            document.querySelectorAll('.js-twer-popup').forEach(element => {
              const match = element.classList.value.match(/twer-popup-id-\d+/gm);

              if (match[0]) {
                const $marker = document.getElementById(match[0]);
                if (!!!$marker) {
                  TWER.closePopups();
                }
              }
            });
          }
        });
      }


      // Set start template for Store Locator Marker
      if (TWER.data.storeLocatorMarkerTemplate) {
        this.setMarkerStyle(TWER.data.storeLocatorMarkerTemplate);
      }

      // Add Store Locator Marker after map load
      if (TWER.data.storeLocatorMarker ) {
        let coords = TWER.data.center;
        this.addMarker(this.markerLocationProps, coords);
      }
    });

  },

  addMarker: function(props, coords) {
    const markerElement = this.createNewMarker1(props, coords, '');
    this.markerLocation = new mapboxgl.Marker(markerElement).setLngLat(coords).addTo(TWER.map);
  },


  setMarkerStyle: function(props) {
    this.markerLocationProps = {...this.markerLocationProps, ...JSON.parse(props)};
  },

  removeMarker: function() {
    this.markerLocation.remove();
  },

  isMarker: function(target) {
    let isMarker = false;

    if(target.classList.contains('js-twer-marker') || target.classList.contains('treweler-marker') || target.closest('.js-twer-marker')?.classList.contains('js-twer-marker')) {
      isMarker = true;
    }
    return isMarker;
  },

  isCluster : function(target) {
    let isCluster = false;

    if(target.classList.contains('marker__center') || target.classList.contains('marker__border') || target.closest('.mapboxgl-marker')?.classList.contains('treweler-cluster')) {
      isCluster = true;
    }
    return isCluster;
  },

  onClickMap: function() {
    TWER.map.on('click', (event) => {
      if (event.originalEvent.target.classList.contains('mapboxgl-canvas')) {
        TWER.closePopups();
      }


      if (TWER.data.storeLocatorMarker && !this.isMarker( event.originalEvent.target ) && !this.isCluster( event.originalEvent.target )) {
        this.removeMarker();
        this.addMarker(this.markerLocationProps, event.lngLat.wrap());
      }

      // Exist from tour if click on map
      TWER.tourInProgress = false;


      if(TWER.data.mapCenterOnClick && !this.isMarker(event.originalEvent.target) && !this.isCluster( event.originalEvent.target )) {
        TWER.map.flyTo({
          center: event.lngLat.wrap(),
          essential: true,
        });
      }


    });
  },
  onClickMapTour: function() {
    document.getElementById('twer-map').addEventListener('click', event => {
      const $element = event.target;

      if (!!!$element.closest('.js-twer-popup') && !$element.classList.contains('js-twer-marker') && !!!$element.closest('.js-twer-marker')) {
        TWER.closeTourPopup();
      }
    });
  },

  closeTourPopup: function() {

    if (TWER.popups === undefined || TWER.popups.length === 0) return false;
    TWER.popups.forEach((popup, index, arr) => {
      if (popup._container) {
        if (popup._container.classList.contains('twer-popup--AlwaysShow')) return false;
        if (popup._container.classList.contains('twer-popup--show')) return false;
        if (popup._container.classList.contains('twer-popup--OpenDefault') && parseInt(localStorage.getItem('toggleTourNeverRunning')) === 0) return false;

        let $rootElement;

        if (popup._container.classList.contains('js-twer-popup')) {
          $rootElement = popup._container;
        }
        if (!!popup._container.closest('.js-twer-popup')) {
          $rootElement = popup._container.closest('.js-twer-popup');
        }

        $rootElement.classList.remove('twer-popup--TourShow');
        $rootElement.classList.remove('twer-popup--OpenDefault');

        setTimeout(function() {
          popup.remove();
        }, 600); // ori 250

        TWER.popups.splice(index, 1);

      }
    });
    document.querySelectorAll('.js-twer-marker').forEach(element => {
      element.classList.remove('open');
    });
  },
  closePopups: function(ids = [], params = {}, ...args) {

    if (TWER.popups === undefined || TWER.popups.length === 0) return false;

    let exceptIds = [];

    if (params.hasOwnProperty('except')) {
      exceptIds = params.except;
    }

    TWER.popups.forEach((popup, index) => {

      // Check if popup container exist and all it`s good
      if (typeof popup._container !== 'undefined') {
        if (popup._container.classList.contains('twer-popup--AlwaysShow')) return;
        if (popup._container.classList.contains('twer-popup--TourShow')) return;

        const popupId = parseInt(popup.options.metadata.id);

        // Only close elements by ID else close all popups
        let idsCloseStatus = false;
        if (ids.length !== 0) {
          for (let i = 0; i < ids.length; i++) {
            if (ids[i] !== popupId) {
              idsCloseStatus = true;
            }
          }
        }

        // Ignore close popups by exceptIds data else close all popups
        let exceptIdsStatus = false;
        exceptIds.forEach((exceptId) => {
          if (popup._container.classList.contains(`twer-popup-id-${exceptId}`)) {
            exceptIdsStatus = true;
          }
        });
        if (exceptIdsStatus) return;
        if (idsCloseStatus) return;

        popup.removeClassName('twer-popup--show');
        popup.removeClassName('twer-popup--OpenDefault');

        // Set pause before remove popup
        setTimeout(() => {
          popup.remove();
        }, TWER.animationDelayClose);

        TWER.popups[index] = null;
      }
    });

    // Remove all null values from array
    TWER.popups = TWER.popups.filter(function(el) {
      return el != null;
    });

    document.querySelectorAll('.js-twer-marker').forEach(element => {
      element.classList.remove('open');
    });
  },

  openPopup: function(event, coords, params = {}, ...args) {
    const $element = event.target;
    const $popup = document.getElementsByClassName($element.getAttribute('id'))[0];

    if ($popup !== undefined) return false;

    let togglePopups = true;
    if (params.hasOwnProperty('toggle')) {
      togglePopups = params.toggle;
    }

    if (togglePopups) {
      // Before open popup, close siblings popups
      TWER.closePopups();
      TWER.closeTourPopup();
    }

    if (!$element.classList.contains('open') && ($element.classList.contains('js-twer-marker') || !!$element.closest('.js-twer-marker'))) {
      let $template, $rootElement;
      const range = document.createRange();

      if ($element.classList.contains('js-twer-marker')) {
        $rootElement = $element;
        $template = $rootElement.getElementsByTagName('template')[0];
      }
      if (!!$element.closest('.js-twer-marker')) {
        $rootElement = $element.closest('.js-twer-marker');
        $template = $rootElement.getElementsByTagName('template')[0];
      }

      if (!!$template) {
        const someDiv = document.createElement('DIV');
        const documentFragment = range.createContextualFragment($template.innerHTML);
        someDiv.appendChild(documentFragment);
        const classLists = someDiv.getElementsByClassName('js-twer-popup__wrap')[0].dataset.class;
        const id = someDiv.getElementsByClassName('js-twer-popup__wrap')[0].dataset.idpopup;
        const borderRadius = someDiv.getElementsByClassName('js-twer-popup__wrap')[0].dataset.borderradius;
        const minwidthalternate = someDiv.getElementsByClassName('js-twer-popup__wrap')[0].dataset.minwidthalternate;

        someDiv.getElementsByClassName('js-twer-popup__wrap')[0].removeAttribute('data-class');
        someDiv.getElementsByClassName('js-twer-popup__wrap')[0].removeAttribute('data-idpopup');
        someDiv.getElementsByClassName('js-twer-popup__wrap')[0].removeAttribute('data-borderradius');
        someDiv.getElementsByClassName('js-twer-popup__wrap')[0].removeAttribute('data-minwidthalternate');

        const templateHtml = someDiv.innerHTML;

        $rootElement.classList.add('open');

        let offsetPopup = 14;

        if ($rootElement.classList.contains('twer-marker-type--balloon-default')) {
          offsetPopup = parseInt($rootElement.getElementsByClassName('marker-svg')[0].dataset.height) + 3;
        }
        if ($rootElement.classList.contains('twer-marker-type--triangle-default')) {
          offsetPopup = parseInt($rootElement.getElementsByClassName('marker-triangle')[0].dataset.height) + 10;
          offsetPopup = parseInt(offsetPopup / 2);
        }

        // Show popup after marker click
        const popup = new mapboxgl.Popup({
          closeButton: false,
          className: classLists,
          closeOnClick: false,
          focusAfterOpen: false,
          anchor: 'bottom',
          offset: offsetPopup,
          metadata: {
            id: id
          }
        }).setLngLat(coords).setHTML(templateHtml).setMaxWidth('none').addTo(TWER.map);

        popup._content.style.borderRadius = `${borderRadius}px`;

        if (minwidthalternate.length > 0) {
          const currentStyleAttrVal = popup._content.closest('.js-twer-popup').getAttribute('style');
          popup._content.closest('.js-twer-popup').setAttribute('style', `min-width:${minwidthalternate}px !important;${currentStyleAttrVal}`);
        }

        setTimeout(function() {
          popup.addClassName('twer-popup--show');
        }, TWER.animationDelayOpen);

        TWER.popups.push(popup);
      }

    }

    document.activeElement.blur();

    jQuery( window.wp.mediaelement.initialize );
  },
  clustersHandlers: function() {

    TWER.map.on('click', 'clusters', (event) => {
      TWER.globalClusterStatus = true;

      const features = TWER.map.queryRenderedFeatures(event.point, {
        layers: ['clusters']
      });

      const clusterId = features[0].properties.cluster_id;

      TWER.map.getSource('locations').getClusterExpansionZoom(clusterId, (err, zoom) => {
          if (err) return;

          TWER.map.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom + 0.5
          });
        }
      );

    });

    TWER.map.on('mouseenter', 'clusters', () => {
      TWER.map.getCanvas().style.cursor = 'pointer';
    });

    TWER.map.on('mouseleave', 'clusters', () => {
      TWER.map.getCanvas().style.cursor = '';
    });
  },

  hex2rgba: function(hex, opacity) {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r},${g},${b},${opacity})`;
  },
  isEmpty: function(obj) {
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }

    return JSON.stringify(obj) === JSON.stringify({});
  },
  createNewCluster: function(props) {
    const clusterElement = document.createElement('div');
    clusterElement.innerHTML = `<div class="treweler-marker-cluster"><div class="marker marker--cluster" >
                             <div class="marker-wrap">
                             <div class="marker__shadow" style="border-color:${TWER.hex2rgba(TWER.clusterColor, 0.1)}">
                             <div class="marker__border" style="border-color:${TWER.hex2rgba(TWER.clusterColor, 0.4)}">
                             <div class="marker__center" style="background-color:${TWER.clusterColor};">${props.point_count}</div>
                             </div>
                             </div>
                             </div>
                             </div></div>`;
    clusterElement.classList.add('treweler-cluster');
    clusterElement.classList.add('trew-cluster-id-' + props.cluster_id);

    return clusterElement;
  },
  createNewMarker1: function(props, coords, desc) {

    const markerElement = document.createElement('div');

    if (props.marker_style === 'default') {
      markerElement.innerHTML = `<div class="treweler-marker"><div class="marker">
                 <div class="marker-wrap">
                 <div class="marker__shadow" style="background-color:${TWER.hex2rgba(props.point_halo_color, props.point_halo_opacity)}">
                 <div class="marker__border" style="border-color:${props.point_color};">
                 <div class="marker__center"></div>
                 </div>
                 </div>
                 </div>
                 </div></div>`;
    } else if ('dot-default' === props.marker_style) {
      let iconHtml = '';
      if (props.dot_icon_picker.length > 0 && props.dot_icon_show > 0) {
        iconHtml = `<span class="marker-dot__icon material-icons material-icons--reset" style="color:${props.dot_icon.color};font-size:${props.dot_icon.size}px;">${props.dot_icon_picker}</span>`;
      }

      markerElement.innerHTML = `<div class="treweler-marker" style="width:${props.dot.size}px;height:${props.dot.size}px;border-radius:${props.dot_corner_radius.size}${props.dot_corner_radius.units};border:${props.dot_border.size}px solid ${props.dot_border.color};background-color:${props.dot.color};">${iconHtml}</div>`;
    } else if ('triangle-default' === props.marker_style) {
      const styleTriangle = `
                        border-right-width:${props.triangle_width / 2}px;
                        border-left-width:${props.triangle_width / 2}px;
                        border-bottom-width: ${props.triangle_height}px;
                        border-bottom-color: ${props.triangle_color};
                        `;
      markerElement.innerHTML = `<div data-height="${props.triangle_height}" class="treweler-marker marker-triangle" style="${styleTriangle}"></div>`;
    } else if ('balloon-default' === props.marker_style) {

      const realMarkerSizeBalloon = props.balloon.size + (props.balloon_border.size + props.balloon_border.size);
      const x = ((realMarkerSizeBalloon + realMarkerSizeBalloon - Math.sqrt(Math.pow(realMarkerSizeBalloon, 2) + Math.pow(realMarkerSizeBalloon, 2))) * (Math.sqrt(2) - 1) / 2);

      let styleBalloon = `
                        background-color: ${props.balloon.color};    
                        border: ${props.balloon_border.size}px solid ${props.balloon_border.color};
                        bottom:${x + x}px;                        
                        width: ${props.balloon.size}px;
                        height: ${props.balloon.size}px;`;

      let styleBalloonDot = `
                        width:${props.balloon_dot.size}px;
                        height:${props.balloon_dot.size}px;
                        margin-left:${(props.balloon_dot.size / 2) * -1}px;
                        margin-top:${(props.balloon_dot.size / 2) * -1}px;
                        background-color:${props.balloon_dot.color};
                        `;

      let iconHtml = '';
      if (props.balloon_icon_picker.length > 0 && props.balloon_icon_show > 0) {
        iconHtml = `<span class="marker-balloon__icon material-icons material-icons--reset" style="color:${props.balloon_icon.color};font-size:${props.balloon_icon.size}px;">${props.balloon_icon_picker}</span>`;
      }

      markerElement.innerHTML = `<div data-width="${props.balloon.size}" data-height="${realMarkerSizeBalloon + x + x}" class="treweler-marker marker-svg"><div class="marker-balloon" style="${styleBalloon}"><div class="marker-balloon__dot" style="${styleBalloonDot}">${iconHtml}</div></div></div>`;
      props.anchor = 'bottom';
    } else if ('custom' === props.marker_style) {
      const size = props.custom_marker_size_default !== '' ? props.custom_marker_size_default.split(';') : '42;42'.split(';');
      markerElement.className = 'treweler-marker icon';
      markerElement.style.backgroundImage = `url('${props.custom_marker_img}')`;
      markerElement.style.backgroundSize = 'contain';
      markerElement.style.backgroundRepeat = 'no-repeat';
      markerElement.style.backgroundPosition = 'center center';
      const width = (parseInt(size[1]) <= 42 ? (parseInt(size[1]) % 2 === 0 ? parseInt(size[1]) : parseInt(size[1]) + 1) : 42);
      const height = (parseInt(size[0]) <= 42 ? (parseInt(size[0]) % 2 === 0 ? parseInt(size[0]) : parseInt(size[0]) + 1) : 42);
      const finalWidth = parseInt(props.custom_marker_size) > 1 ? parseInt(props.custom_marker_size) : width;
      const finalHeight = parseInt(props.custom_marker_size) > 1 ? parseInt(props.custom_marker_size) : height;
      markerElement.style.width = `${finalWidth}px`;
      markerElement.style.height = `${finalHeight}px`;
      props.anchor = props.custom_marker_position;
    } else {
      markerElement.innerHTML = `<div class="treweler-marker"><div class="marker">
                 <div class="marker-wrap">
                 <div class="marker__shadow" style="background-color:${TWER.hex2rgba(props.point_halo_color, props.point_halo_opacity)}">
                 <div class="marker__border" style="border-color:${props.point_color};">
                 <div class="marker__center"></div>
                 </div>
                 </div>
                 </div>
                 </div></div>`;
      props.anchor = 'center';
    }

    markerElement.classList.add(`js-twer-marker`);

    markerElement.setAttribute('id', `twer-popup-id-${props.id}`);

    // Add marker style class
    markerElement.classList.add(`twer-cursor-${props.cursor}`);

    // Add type of marker
    markerElement.classList.add(`twer-marker-type--${props.marker_style}`);

    return {
      element: markerElement,
      anchor: props.anchor
    };
  },

  createNewMarker: function(props, coords, desc) {
    let showPopup = true;
    if (props.hasOwnProperty('showPopup')) {
      showPopup = props.showPopup;
    }


    const markerElement = document.createElement('div');

    let tourIndexNumberHTML = ``
    if(props.tourIndexNumber !== '') {
      const styles = [];
      const tourNumberFontColor = TWER.data.tourNumberSettings.fontColor;
      const tourNumberFontSize = TWER.data.tourNumberSettings.fontSize;
      const tourNumberFontWeight = TWER.data.tourNumberSettings.fontWeight;

      const tourNumberOffsetTop = TWER.data.tourNumberSettings.offset.top;
      const tourNumberOffsetBottom = TWER.data.tourNumberSettings.offset.bottom;
      const tourNumberOffsetLeft = TWER.data.tourNumberSettings.offset.left;
      const tourNumberOffsetRight = TWER.data.tourNumberSettings.offset.right;



      styles.push(`color:${tourNumberFontColor};`);
      styles.push(`font-size:${tourNumberFontSize}px;`);
      styles.push(`font-weight:${tourNumberFontWeight};`);

      styles.push(`padding-top:${tourNumberOffsetTop}px;`);
      styles.push(`padding-bottom:${tourNumberOffsetBottom}px;`);
      styles.push(`padding-left:${tourNumberOffsetLeft}px;`);
      styles.push(`padding-right:${tourNumberOffsetRight}px;`);

      tourIndexNumberHTML = `<div class="twer-tour-index-number" style="${styles.join('')}">${props.tourIndexNumber}</div>`
    }

    if (props.icon === '' || props.icon === undefined) {
      if (props.type === 'default') {
        markerElement.innerHTML = `${tourIndexNumberHTML}<div class="treweler-marker"><div class="marker">
                 <div class="marker-wrap">
                 <div class="marker__shadow" style="background-color:${TWER.hex2rgba(props.halo_color, props.halo_opacity)}">
                 <div class="marker__border" style="border-color:${props.color};">
                 <div class="marker__center"></div>
                 </div>
                 </div>
                 </div>
                 </div></div>`;
      } else if ('dot-default' === props.type) {
        let iconHtml = '';
        if (props.dot_icon.length > 0 && props.dot_icon_show > 0) {
          iconHtml = `<span class="marker-dot__icon material-icons material-icons--reset" style="color:${props.dot_icon_color};font-size:${props.dot_icon_size}px;">${props.dot_icon}</span>`;
        }

        markerElement.innerHTML = `${tourIndexNumberHTML}<div class="treweler-marker" style="width:${props.inner_size}px;height:${props.inner_size}px;border-radius:${props.corner_radius}${props.corner_radius_units};border:${props.border_width}px solid ${props.border_color};background-color:${props.dotcenter_color};">${iconHtml}</div>`;
      } else if ('triangle-default' === props.type) {
        const styleTriangle = `
                        border-right-width:${props.width_triangle / 2}px;
                        border-left-width:${props.width_triangle / 2}px;
                        border-bottom-width: ${props.height_triangle}px;
                        border-bottom-color: ${props.color_triangle};
                        `;
        markerElement.innerHTML = `${tourIndexNumberHTML}<div data-height="${props.height_triangle}" class="treweler-marker marker-triangle" style="${styleTriangle}"></div>`;
      } else if ('balloon-default' === props.type) {

        const realMarkerSizeBalloon = props.size_balloon + (props.border_width_balloon + props.border_width_balloon);
        const x = ((realMarkerSizeBalloon + realMarkerSizeBalloon - Math.sqrt(Math.pow(realMarkerSizeBalloon, 2) + Math.pow(realMarkerSizeBalloon, 2))) * (Math.sqrt(2) - 1) / 2);

        let styleBalloon = `
                        background-color: ${props.color_balloon};    
                        border: ${props.border_width_balloon}px solid ${props.border_color_balloon};
                        bottom:${x + x}px;                        
                        width: ${props.size_balloon}px;
                        height: ${props.size_balloon}px;`;

        let styleBalloonDot = `
                        width:${props.dot_size}px;
                        height:${props.dot_size}px;
                        margin-left:${(props.dot_size / 2) * -1}px;
                        margin-top:${(props.dot_size / 2) * -1}px;
                        background-color:${props.dot_color};
                        `;

        let iconHtml = '';
        if (props.balloon_icon.length > 0 && props.balloon_icon_show > 0) {
          iconHtml = `<span class="marker-balloon__icon material-icons material-icons--reset" style="color:${props.balloon_icon_color};font-size:${props.balloon_icon_size}px;">${props.balloon_icon}</span>`;
        }

        markerElement.innerHTML = `${tourIndexNumberHTML}<div data-width="${props.size_balloon}" data-height="${realMarkerSizeBalloon + x + x}" class="treweler-marker marker-svg"><div class="marker-balloon" style="${styleBalloon}"><div class="marker-balloon__dot" style="${styleBalloonDot}">${iconHtml}</div></div></div>`;
        props.anchor = 'bottom';
      } else {
        if ((props.type !== 'custom')) {
          const haloColor = props.halo_color;
          const haloOpacity = props.halo_opacity;
          const borderColor = props.color;
          markerElement.innerHTML = `${tourIndexNumberHTML}<div class="treweler-marker"><div class="marker">
                 <div class="marker-wrap">
                 <div class="marker__shadow" ${haloColor && haloOpacity ? 'style="background-color:' + TWER.hex2rgba(haloColor, haloOpacity) + '"' : ''}>
                 <div class="marker__border" ${borderColor ? 'style="border-color:' + borderColor + '"' : ''}>
                 <div class="marker__center"></div>
                 </div>
                 </div>
                 </div>
                 </div></div>`;
          props.anchor = 'center';
        }
      }

    } else {
      const size = props.size !== '' ? props.size.split(';') : '42;42'.split(';');
      markerElement.className = 'treweler-marker icon';
      markerElement.style.backgroundImage = `url('${props.icon}')`;
      markerElement.style.backgroundSize = 'contain';
      markerElement.style.backgroundRepeat = 'no-repeat';
      markerElement.style.backgroundPosition = 'center center';
      const width = (parseInt(size[1]) <= 42 ? (parseInt(size[1]) % 2 === 0 ? parseInt(size[1]) : parseInt(size[1]) + 1) : 42);
      const height = (parseInt(size[0]) <= 42 ? (parseInt(size[0]) % 2 === 0 ? parseInt(size[0]) : parseInt(size[0]) + 1) : 42);
      const finalWidth = parseInt(props.markerSize) > 1 ? parseInt(props.markerSize) : width;
      const finalHeight = parseInt(props.markerSize) > 1 ? parseInt(props.markerSize) : height;
      markerElement.style.width = `${finalWidth}px`;
      markerElement.style.height = `${finalHeight}px`;
      markerElement.innerHTML = `${tourIndexNumberHTML}`;
    }
    markerElement.classList.add(`js-twer-marker`);

    markerElement.setAttribute('id', `twer-popup-id-${props.id}`);

    // Category Handler
    if (typeof props.category !== 'undefined') {
      markerElement.classList.add(...props.category.split(' '));
    }

    // Add marker style class
    markerElement.classList.add(`twer-cursor-${props.cursor}`);

    // Add type of marker
    markerElement.classList.add(`twer-marker-type--${props.type}`);

    // If description exist - add template popup to marker
    if (desc) {
      const $template = document.createElement('template');
      $template.innerHTML = desc;

      if (!!markerElement.getElementsByTagName('template')) {
        markerElement.appendChild($template);
      }

      // Add popup handlers if marker template / description JSON exist
      if ('hover' === props.openby) {
        markerElement.onmouseenter = (event) => {
          this.openPopup(event, coords);
        };
        if (props.openDefault && showPopup) {
          this.staticPopUp(markerElement, coords, 3);
        }
      } else if ('click' === props.openby) {
        markerElement.onclick = (event) => {
          this.openPopup(event, coords);
        };
        if (props.openDefault && showPopup) {
          this.staticPopUp(markerElement, coords, 3);
        }

      } else if ('always_open' === props.openby) {
        this.staticPopUp(markerElement, coords, 1);
      }
    }

    // Hide marker
    if (props.markerHide) {
      let $rootMarker = [undefined];

      if (markerElement.classList.contains('twer-marker-type--dot-default')) {
        $rootMarker = markerElement.getElementsByClassName('treweler-marker');
      } else if (markerElement.classList.contains('twer-marker-type--default')) {
        $rootMarker = markerElement.getElementsByClassName('marker');
      } else if (markerElement.classList.contains('twer-marker-type--balloon-default')) {
        $rootMarker = markerElement.getElementsByClassName('treweler-marker');
      } else if (markerElement.classList.contains('twer-marker-type--triangle-default')) {
        $rootMarker = markerElement.getElementsByClassName('treweler-marker marker-triangle');
      } else if (markerElement.classList.contains('twer-marker-type--custom')) {
        markerElement.style.backgroundImage = 'none';
      }

      if (typeof $rootMarker[0] !== 'undefined') {
        $rootMarker[0].style.visibility = 'hidden';
        $rootMarker[0].style.opacity = 0;
        $rootMarker[0].style.overflow = 'hidden';
        $rootMarker[0].style.height = 0;
        $rootMarker[0].style.width = 0;
      }
    }

    // Show marker labels
    if (props.markerLabelEnable) {

      const labelParams = props.label;
      const desc = labelParams.description.toString();

      if (!lodash.isEmpty(desc)) {
        const $templateLabel = document.getElementById('js-twer-marker-label');
        markerElement.appendChild(document.importNode($templateLabel.content, true));
        const $label = markerElement.getElementsByClassName('twer-marker-label')[0];
        $label.classList.add(`twer-marker-label--${labelParams.position}`);
        $label.innerHTML = desc.trim();
        $label.style.color = labelParams.font_color;
        $label.style.fontSize = `${labelParams.font_size}px`;
        $label.style.fontWeight = labelParams.font_weight;
        $label.style.letterSpacing = `${labelParams.letter_spacing}px`;
        $label.style.lineHeight = labelParams.line_height;

        if (labelParams.label_has_bg) {
          $label.classList.add(`twer-marker-label--has-bg`);
          $label.style.borderRadius = `${labelParams.label_border_radius}px`;
          $label.style.paddingTop = `${labelParams.label_padding.top}px`;
          $label.style.paddingBottom = `${labelParams.label_padding.bottom}px`;
          $label.style.paddingLeft = `${labelParams.label_padding.left}px`;
          $label.style.paddingRight = `${labelParams.label_padding.right}px`;

        }
      }
    }

    return {
      element: markerElement,
      anchor: props.anchor
    };
  },
  __afterCreateNewMarker: (marker, props, coords) => {
    if (props.markerLabelEnable && props.label.description) {
      let lineHeightDiff = 0; // Block size error due to text line-height.
      const labelParams = props.label;
      const $label = marker.element.getElementsByClassName('twer-marker-label')[0];
      const $markerInner = marker.element.getElementsByClassName('marker');
      const $markerInnerSvg = marker.element.getElementsByClassName('marker-svg');
      let $rootMarker = [undefined];

      let sizeMarker = [30, 30];
      let sizeLabel = [103, 88];

      if ($markerInner.length > 0) {
        $rootMarker = $markerInner;
      } else if ($markerInnerSvg.length > 0) {
        $rootMarker = $markerInnerSvg;
      } else {
        $rootMarker = [marker.element];
      }

      if (typeof $rootMarker[0] !== 'undefined') {
        sizeMarker[0] = $rootMarker[0].getBoundingClientRect().width;
        sizeMarker[1] = $rootMarker[0].getBoundingClientRect().height;

        if ($rootMarker[0].classList.contains('marker-svg')) {
          const bottomValue = parseInt($rootMarker[0].getElementsByClassName('marker-balloon')[0].style.bottom);
          sizeMarker[1] = sizeMarker[1] + bottomValue;

          $rootMarker[0].getElementsByClassName('marker-balloon')[0].style.bottom = 0;
        }

        $rootMarker[0].style.left = '0px';
        $rootMarker[0].style.top = '0px';
        $rootMarker[0].closest('.js-twer-marker, .treweler-marker').style.width = `${sizeMarker[0]}px`;
        $rootMarker[0].closest('.js-twer-marker, .treweler-marker').style.height = `${sizeMarker[1]}px`;
      }

      sizeLabel[0] = $label.getBoundingClientRect().width - lineHeightDiff;
      sizeLabel[1] = $label.getBoundingClientRect().height - lineHeightDiff;

      if (labelParams.position === 'top' || labelParams.position === 'bottom') {
        sizeMarker[0] = sizeMarker[0] - 1;
        sizeMarker[1] = sizeMarker[1] - 1;
      }

      if (labelParams.position === 'bottom_right' || labelParams.position === 'bottom_left' || labelParams.position === 'top_right' || labelParams.position === 'top_left') {

        if (sizeMarker[0] === 30) {
          sizeMarker[0] -= 7;
        }
        if (sizeMarker[1] === 30) {
          sizeMarker[1] -= 7;
        }
      }

      let offset = labelParams.margin - lineHeightDiff;
      switch (labelParams.position) {
        case 'left' :
        case 'right' :
          $label.style.marginTop = `-${sizeLabel[1] / 2}px`;
          break;
        case 'top' :
        case 'bottom' :
          $label.style.marginLeft = `-${sizeLabel[0] / 2}px`;
          break;
        case 'center' :
          $label.style.marginLeft = `-${sizeLabel[0] / 2}px`;
          $label.style.marginTop = `-${sizeLabel[1] / 2}px`;
          break;

      }
      switch (labelParams.position) {
        case 'right' :
          $label.style.left = `${offset + sizeMarker[0]}px`;
          break;
        case 'bottom_right' :
          $label.style.left = `${offset + sizeMarker[0]}px`;
          $label.style.top = `${offset + sizeMarker[1]}px`;
          break;
        case 'top_right' :
          $label.style.left = `${offset + sizeMarker[0]}px`;
          $label.style.bottom = `${offset + sizeMarker[1]}px`;
          break;
        case 'left' :
          $label.style.right = `${offset + sizeMarker[0]}px`;
          break;
        case 'bottom_left' :
          $label.style.right = `${offset + sizeMarker[0]}px`;
          $label.style.top = `${offset + sizeMarker[1]}px`;
          break;
        case 'top_left' :
          $label.style.right = `${offset + sizeMarker[0]}px`;
          $label.style.bottom = `${offset + sizeMarker[1]}px`;
          break;
        case 'top' :
          $label.style.bottom = `${offset + sizeMarker[1]}px`;
          break;
        case 'bottom' :
          $label.style.top = `${offset + sizeMarker[1]}px`;
          break;
      }
    }

    if (props.allowMarkerCenterOnClick) {
      marker.element.addEventListener('click', (event) => {
        event.preventDefault();
        TWER.map.flyTo({
          center: coords,
          padding: {
            top: props.markerClickOffset.top,
            bottom: props.markerClickOffset.bottom,
            left: props.markerClickOffset.left,
            right: props.markerClickOffset.right
          }
        });
      });
    }


    if(props.markerLink.enable) {
      marker.element.addEventListener('click', (event) => {
        event.preventDefault();
        let target = props.markerLink.openInNewWindow ? '_blank' : '_self';
        if(TWER.isIframeMap() && !props.markerLink.openInNewWindow) {
          target = '_parent';
        }

        window.open(props.markerLink.url, target);
      });
    }
  },

  isIframeMap: function() {
    return document.body.classList.contains('twer-page-iframe-map');
  },

  staticPopUp: function(element, coords, showForever, idPop) {

    const $element = element;
    const $popup = document.getElementsByClassName($element.getAttribute('id'))[0];

    if ($popup !== undefined) return false;

    if (!$element.classList.contains('open') && ($element.classList.contains('js-twer-marker') || !!$element.closest('.js-twer-marker'))) {
      let $template, $rootElement;
      const range = document.createRange();

      if ($element.classList.contains('js-twer-marker')) {
        $rootElement = $element;
        $template = $rootElement.getElementsByTagName('template')[0];
      }
      if (!!$element.closest('.js-twer-marker')) {
        $rootElement = $element.closest('.js-twer-marker');
        $template = $rootElement.getElementsByTagName('template')[0];
      }

      if (!!$template) {
        const someDiv = document.createElement('DIV');
        const documentFragment = range.createContextualFragment($template.innerHTML);
        someDiv.appendChild(documentFragment);
        const classLists = someDiv.getElementsByClassName('js-twer-popup__wrap')[0].dataset.class;
        const id = someDiv.getElementsByClassName('js-twer-popup__wrap')[0].dataset.idpopup;
        const borderRadius = someDiv.getElementsByClassName('js-twer-popup__wrap')[0].dataset.borderradius;
        const minwidthalternate = someDiv.getElementsByClassName('js-twer-popup__wrap')[0].dataset.minwidthalternate;

        someDiv.getElementsByClassName('js-twer-popup__wrap')[0].removeAttribute('data-class');
        someDiv.getElementsByClassName('js-twer-popup__wrap')[0].removeAttribute('data-idpopup');
        someDiv.getElementsByClassName('js-twer-popup__wrap')[0].removeAttribute('data-borderradius');
        someDiv.getElementsByClassName('js-twer-popup__wrap')[0].removeAttribute('data-minwidthalternate');

        const templateHtml = someDiv.innerHTML;

        $rootElement.classList.add('open');

        let offsetPopup = 14;

        if ($rootElement.classList.contains('twer-marker-type--balloon-default')) {
          offsetPopup = parseInt($rootElement.getElementsByClassName('marker-svg')[0].dataset.height) + 3;
        }

        if ($rootElement.classList.contains('twer-marker-type--triangle-default')) {
          offsetPopup = parseInt($rootElement.getElementsByClassName('marker-triangle')[0].dataset.height) + 10;
          offsetPopup = parseInt(offsetPopup / 2);
        }

        // Show popup after marker click
        const popup = new mapboxgl.Popup({
          className: classLists,
          closeButton: false,
          closeOnClick: false,
          anchor: 'bottom',
          focusAfterOpen: false,
          offset: offsetPopup,
          metadata: {
            id: id
          }
        }).setLngLat(coords).setHTML(templateHtml).setMaxWidth('none').addTo(TWER.map);

        popup._content.style.borderRadius = `${borderRadius}px`;

        if (minwidthalternate.length > 0) {
          const currentStyleAttrVal = popup._content.closest('.js-twer-popup').getAttribute('style');
          popup._content.closest('.js-twer-popup').setAttribute('style', `min-width:${minwidthalternate}px !important;${currentStyleAttrVal}`);
        }

        if (showForever === 1) {
          setTimeout(function() {
            popup.addClassName('twer-popup--AlwaysShow');
          }, 110);
        } else if (showForever === 2) {
          popup.addClassName('twer-popup--TourShow');
        } else if (showForever === 3) {
          setTimeout(function() {
            popup.addClassName('twer-popup--OpenDefault');
          }, 110);

        } else {
          popup.addClassName('twer-popup--show');

        }

        TWER.popups.push(popup);
      }

    }

    document.activeElement.blur();
  },
};
